export const CONTAINER_SELECTOR = '[data-rfkid="rfkid_container"]';
export const getContainerNode = () => document.querySelector(CONTAINER_SELECTOR);
export const isContainer = () => !!getContainerNode();
